// removed by extract-text-webpack-plugin
module.exports = {"buttonLine":"_4NzfC-gVU371m5iFTPqOw","successPromoted":"_3CjiWGjwIKkmenqgGCsLV5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpgradeRegularUserPackage/UpgradeRegularUserPackage.scss
// module id = 1866
// module chunks = 0